import React, { useState } from 'react';
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import GridColumnSettingsDialog from './GridColumnSettingsDialog';

/**
 * 표 위 공통 툴바. 기존 85곳이 쓰던 fileName/showExport 는 그대로 동작한다.
 *
 * gridPersonalization 은 ResponsiveDataGrid 가 slotProps.toolbar 로 얹어 준다(컨테이너가 이 prop을
 * 직접 넘길 필요는 없다). 열 설정 버튼이 MUI 기본 GridToolbarColumnsButton(칼럼 패널)을 대신한다 —
 * 우리 쪽 "열 설정" 다이얼로그가 순서 바꾸기까지 겸하기 때문.
 */
const CustomToolbar = ({ fileName, showExport, gridPersonalization }) => {
  const [columnDialogOpen, setColumnDialogOpen] = useState(false);
  const filterHidden = Boolean(gridPersonalization?.filterHidden);

  return (
    <GridToolbarContainer>
      {gridPersonalization && (
        <Button size="small" startIcon={<ViewColumnIcon />} onClick={() => setColumnDialogOpen(true)}>
          열 설정
        </Button>
      )}
      {!filterHidden && <GridToolbarFilterButton />}
      <GridToolbarDensitySelector />
      {!showExport && (<GridToolbarExport
        csvOptions={{ fileName: fileName, utf8WithBom: true }}
      />)}
      <GridToolbarQuickFilter placeholder="표 안에서 검색" sx={{ ml: 'auto' }} />

      {gridPersonalization && (
        <GridColumnSettingsDialog
          open={columnDialogOpen}
          onClose={() => setColumnDialogOpen(false)}
          columns={gridPersonalization.columns}
          codeVisibilityModel={gridPersonalization.codeVisibilityModel}
          hidden={gridPersonalization.hidden}
          onApply={gridPersonalization.onApply}
          onReset={gridPersonalization.onReset}
        />
      )}
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
